(function () {
    'use strict';
    /*
     * Copyright (c) 2016-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ModalExerciseQuickViewCtrl', ModalExerciseQuickViewCtrl);

    ModalExerciseQuickViewCtrl.$inject = ['$scope', '$modalInstance', 'selectedItem', 'RestResources', 'retrieveValidTargets', 'Utilities'];

    /**
     * This controller is responsible for the display and controls presented in the
     * exercise quick view modal
     */
    function ModalExerciseQuickViewCtrl($scope, $modalInstance, selectedItem, RestResources, retrieveValidTargets, Utilities) {
        $scope.selectedItem = selectedItem;
        $scope.validTargets = retrieveValidTargets();

        $scope.tabState = {
            noOverview: !$scope.selectedItem.overviewVideo
        };

        /**
         * Closes the dialog with an negative (Cancel) choice.
         */
        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };

        /**
         * Closes the modal with a result object containing the
         * selected index, selected item, and the target.
         *
         * @param {Number} index - the index of the selected target
         * @param {Object} target - the selected target
         * @returns {undefined}
         */
        $scope.addExercise = function (index, target) {
            if (angular.isArray(target)) {
                target = angular.copy(target[0]);
            }

            $modalInstance.close({
                index: index,
                item: $scope.selectedItem,
                target: target
            });
        };

        /**
         * This function returns the selected item thumbnail URL
         *
         * @returns {String} thumbnailUrl - the thumbnail media url
         */
        $scope.getMediaThumbnailUrl = function() {
            return $scope.selectedItem.thumbnailUrl;
        };

        /**
         * This function returns the item's overview video URL
         *
         * @returns {String} videoUrl - the video url
         */
        var getOverviewVideoUrl = function() {
            var selectedItem = $scope.selectedItem;
            var overviewVideo = selectedItem.overviewVideo;
            var mediaUrl;

            if (Utilities.isDefinedAndNotNull(overviewVideo)) {
                mediaUrl = RestResources.getExerciseVideoUrl(selectedItem, selectedItem.overviewVideo);
            }

            return mediaUrl;
        };

        /**
         * This function returns the item's exercise video URL
         *
         * @returns {String} videoUrl - the video url
         */
        var getExerciseVideoUrl = function() {
            var selectedItem = $scope.selectedItem;
            var exerciseVideo = selectedItem.exerciseVideo;
            var mediaUrl;

            if (Utilities.isDefinedAndNotNull(exerciseVideo)) {
                mediaUrl = RestResources.getExerciseVideoUrl(selectedItem, selectedItem.exerciseVideo);
            }

            return mediaUrl;
        };

        $scope.config = {
            sources: [],
            plugins: {
                controls: {
                    autoHide: true,
                    autoHideTime: 2000
                }
            }
        };
        $scope.overviewConfig = {
            sources: [
                {
                    src: getOverviewVideoUrl(),
                    type: 'video/mp4'
                }
            ]
        };

        $scope.exerciseConfig = {
            sources: [
                {
                    src: getExerciseVideoUrl(),
                    type: 'video/mp4'
                }
            ]
        };
    }
})();